import React from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { showSidebarMenu } from "../../actions/navActions";
import { Button, Form, Menu, Modal, TextArea, Icon } from "semantic-ui-react";
import { socket } from "../../lib/socketio";
import {
  setHasHeaderReceived,
  setHeaderValues,
  setPPID,
  setOperateVersion,
  setSameMenuItemClick,
  setHasAppReceived,
  setUserArray,
} from "../../actions/headerActions";
import { version } from "../../../package.json";
import { useHistory } from "react-router-dom";
import User from "./User";
import ActivityDetector from "react-activity-detector";
import IdleTimeout from "../IdleTimer/IdleTimeout";

const HeaderMenu = ({
  sidebarVisible,
  showSidebar,
  hasHeaderReceived,
  setHasHeaderReceived,
  setPPID,
  headerValues,
  ppid,
}) => {
  const [data, setData] = React.useState();
  // ^ SOFC_HMI 2303 Main/PSM 구분안 적용 관련 추가
  const [activeItem, setActiveItem] = React.useState();
  const operateVersion = useSelector((state) => state.header.operateVersion);
  const currentPLC = useSelector((state) => state.header.currentPLC);

  let control_mode = 0;
  // update 240927, HMI Integrated version
  const sofcConfig = useSelector((state) => state.header.sofcConfig);
  const [message, setMessage] = React.useState(false);
  const [urgentMsg, setUrgentMsg] = React.useState(false);
  const [idle, setIdle] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [urgentModal, setUrgentModal] = React.useState(false);
  const [urgentInfo, setUrgentInfo] = React.useState("");
  const dispatch = useDispatch();
  const user = useSelector((state) => state.nav.user);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const electronApp = useSelector((state) => state.nav.electronApp);
  const userArray = useSelector((state) => state.header.userArray);
  const [userArr, setUserArr] = React.useState(null); // tmp array to update the header menu item

  // const [toggleIcon, setToggleIcon] = React.useState(false);
  // const lastActivityRef = React.useRef(Date.now());
  // const ACTIVITY_CHECK_DELAY = 1500; // 1.5 seconds - how long to wait before showing toggle OFF
  // const [inactiveSeconds, setInactiveSeconds] = React.useState(0);
  // const [isIdle, setIsIdle] = React.useState(false);

  const [selectedPLC, setSelectedPLC] = React.useState("");

  React.useEffect(() => {
    if (!electronApp && currentPLC.length > 0) {
      if (selectedPLC.length > 0 && selectedPLC !== currentPLC) {
        // send the old and new info to ec2 to swap users to another PLC, then set the state variable
        socket.emit("switch plc", {
          ppid: ppid,
          info: `${user.name}:${socket.id}:${userCopy.hmi_role}`,
          old_plc: selectedPLC,
          new_plc: currentPLC,
          user_array: userArray,
        });
        setSelectedPLC(currentPLC);
      } else {
        setSelectedPLC(currentPLC);
        setUserArr(userArray[currentPLC]);
      }
    }
  }, [currentPLC]);

  const history = useHistory();

  const customActivityEvents = ["click", "keydown", "mousemove"];

  const onIdle = () => {
    setIdle(true);
    setShowModal(true);
    // setIsIdle(true);
  };

  const onActive = () => {
    // lastActivityRef.current = Date.now();
    // setToggleIcon(true);
    // setInactiveSeconds(0);
  };

  const handleTClose = () => {
    setShowModal(false);
    setIdle(false);
    // setIsIdle(false);
    // setToggleIcon(true);
    // setInactiveSeconds(0);
    // lastActivityRef.current = Date.now();
  };

  const reset = async () => {
    routeChange();
  };

  // Check if activity has stopped and toggle OFF accordingly, also track inactive seconds
  // React.useEffect(() => {
  //     const checkActivityStop = setInterval(() => {
  //         const timeSinceLastActivity = Date.now() - lastActivityRef.current;
  //         const secondsInactive = Math.floor(timeSinceLastActivity / 1000);

  //         if (timeSinceLastActivity > ACTIVITY_CHECK_DELAY && toggleIcon && !isIdle) {
  //             setToggleIcon(false);
  //         }

  //         if (!toggleIcon && !isIdle) {
  //             setInactiveSeconds(secondsInactive);
  //         }
  //     }, 500); // Check every 500ms

  //     return () => clearInterval(checkActivityStop);
  // }, [toggleIcon, isIdle]);

  React.useEffect(() => {
    if (
      headerValues != null &&
      Object.keys(headerValues).length > 0 &&
      !hasHeaderReceived
    ) {
      socket.emit("hmi app version number", version);
      setData(JSON.parse(JSON.stringify(headerValues)));
      if (electronApp) {
        setPPID(headerValues["29144"]);
      }
    }
  }, [headerValues, ppid]);

  React.useEffect(() => {
    if (!electronApp) {
      function checkUser() {
        socket.on("userDict", (response) => {
          setUserArr(response);
          dispatch(setUserArray(response));
        });

        if (user.hmi_role == "E") {
          setMessage(true);
          if (
            userCopy.hmi_role === "A" ||
            userCopy.hmi_role === "B" ||
            userCopy.hmi_role === "C"
          ) {
            setUrgentMsg(true);
          }
        } else {
          setMessage(false);
          setUrgentMsg(false);
        }
      }

      const intervalID = setInterval(() => {
        checkUser();
      }, 1);

      return () => clearInterval(intervalID);
    }
  }, [user]);

  const handleMenuClick = (value, { name }) => {
    var last = name;
    if (last === operateVersion) {
      dispatch(setSameMenuItemClick(true));
    } else {
      dispatch(setSameMenuItemClick(false));
    }

    dispatch(setOperateVersion(name));
    showSidebar();
    setActiveItem(name);
  };

  // update SOFC : 231127,현재 화면 PPC Version, PLC 구분 띄움 -> PLC라고 따로 만들지,
  const getPPCVersion = (version) => {
    switch (version) {
      case "MAIN":
        return (
          <Menu.Item>
            PPC Version:{" "}
            {typeof data !== "undefined" && data !== null
              ? data["29146"] +
                "." +
                data["29147"] +
                "." +
                data["29148"] +
                "." +
                data["29149"]
              : ""}{" "}
          </Menu.Item>
        );
      case "PSM1":
        return (
          <Menu.Item>
            PPC Version:{" "}
            {typeof data !== "undefined" && data !== null
              ? data["6734"] +
                "." +
                data["6735"] +
                "." +
                data["6736"] +
                "." +
                data["6737"]
              : ""}{" "}
          </Menu.Item>
        );
      case "PSM2":
        return (
          <Menu.Item>
            PPC Version:{" "}
            {typeof data !== "undefined" && data !== null
              ? data["10648"] +
                "." +
                data["10649"] +
                "." +
                data["10650"] +
                "." +
                data["10651"]
              : ""}{" "}
          </Menu.Item>
        );
      case "PSM3":
        return (
          <Menu.Item>
            PPC Version:{" "}
            {typeof data !== "undefined" && data !== null
              ? data["14562"] +
                "." +
                data["14563"] +
                "." +
                data["14564"] +
                "." +
                data["14565"]
              : ""}{" "}
          </Menu.Item>
        );
      case "PSM4":
        return (
          <Menu.Item>
            PPC Version:{" "}
            {typeof data !== "undefined" && data !== null
              ? data["18476"] +
                "." +
                data["18477"] +
                "." +
                data["18478"] +
                "." +
                data["18479"]
              : ""}{" "}
          </Menu.Item>
        );
      case "PSM5":
        return (
          <Menu.Item>
            PPC Version:{" "}
            {typeof data !== "undefined" && data !== null
              ? data["22390"] +
                "." +
                data["22391"] +
                "." +
                data["22392"] +
                "." +
                data["22393"]
              : ""}{" "}
          </Menu.Item>
        );
      default:
        return (
          <Menu.Item>
            PPC Version:{" "}
            {typeof data !== "undefined" && data !== null ? (
              <p> &nbsp;&nbsp;</p>
            ) : (
              ""
            )}{" "}
          </Menu.Item>
        );
    }
  };

  const routeChange = () => {
    // Fire-and-forget: backend will handle the `switch pplt` + userDict updates.
    socket.emit("switch pplt", {
      ppid: ppid,
      info: `${user.name}:${socket.id}:${userCopy.hmi_role}`,
      plc: currentPLC,
    });
    history.push("/ChoosePPLT");
    window.location.reload();
    dispatch(setPPID("0"));
    dispatch(setHasHeaderReceived(false));
    dispatch(setHeaderValues(null));
    dispatch(setHasAppReceived(false));
  };

  const requestAccess = () => {
    socket.emit("request access", {
      ppid: ppid,
      info: `${user.name}:${socket.id}:${userCopy.hmi_role}`,
      plc: currentPLC,
    });
  };

  const addUrgentInfo = () => {
    setUrgentModal(true);
  };

  const handleOk = () => {
    if (urgentInfo.length == 0) {
      alert("Message cannot be Empty");
    } else {
      setUrgentModal(false);
      socket.emit("urgent access", {
        ppid: ppid,
        info: `${user.name}:${socket.id}:${userCopy.hmi_role}`,
        msg: urgentInfo,
        plc: currentPLC,
      });
    }
  };

  const handleClose = () => {
    setUrgentModal(false);
  };

  const handleChange = (event) => {
    const data = event.target.value;
    setUrgentInfo(data);
  };

  const urgentAccessModal = () => (
    <Modal open={urgentModal} size="tiny" centered={false}>
      <Modal.Header>Reason for Urgent Access</Modal.Header>

      <Modal.Content style={styles.content}>
        <Form>
          <TextArea
            placeholder="Reason for Urgent Access"
            value={urgentInfo}
            onChange={handleChange}
          />
        </Form>
      </Modal.Content>

      <Modal.Actions>
        <Button color="green" onClick={handleOk}>
          Ok
        </Button>
        <Button color="red" onClick={handleClose}>
          Cancel
        </Button>
      </Modal.Actions>
    </Modal>
  );

  // @ marine version

  return (
    <div style={styles.sticky}>
      {!electronApp ? (
        <>
          <ActivityDetector
            activityEvents={customActivityEvents}
            enabled={true}
            timeout={1800 * 1000}
            onIdle={onIdle}
            onActive={onActive}
          />
          {idle ? (
            <IdleTimeout
              showModal={showModal}
              handleTClose={handleTClose}
              reset={reset}
            />
          ) : null}{" "}
        </>
      ) : null}
      <Menu inverted style={styles.header}>
        {/* <Menu.Item active={sidebarVisible} icon='bars' onClick={sidebarVisible ? null : showSidebar} style={styles.menu} /> */}
        {/*name을 Main으로 했을 경우, Sidebar 출력 includes함수에서 Maintenance가 걸리는 경우가 있으므로 언더바 추가 */}
        {!electronApp ? (
          <Menu.Item>
            <button style={styles.home_button} onClick={routeChange}>
              SWITCH PPLT
            </button>
          </Menu.Item>
        ) : null}
        <Menu.Item
          name="_MAIN"
          active={activeItem === "_MAIN" && sidebarVisible}
          onClick={handleMenuClick}
          style={currentPLC === "MAIN" ? styles.active : styles.menu_left}
        >
          {" "}
          MAIN{" "}
        </Menu.Item>
        <Menu.Item
          name="_COMMON"
          active={activeItem === "_COMMON" && sidebarVisible}
          onClick={handleMenuClick}
          style={currentPLC === "MMON" ? styles.active : styles.menu_left}
        >
          {" "}
          COMMON{" "}
        </Menu.Item>
        <Menu.Item
          name="_PSM1"
          active={activeItem === "_PSM1" && sidebarVisible}
          onClick={handleMenuClick}
          style={currentPLC === "PSM1" ? styles.active : styles.menu_left}
        >
          {" "}
          PSM 1{" "}
        </Menu.Item>
        <Menu.Item
          name="_PSM2"
          active={activeItem === "_PSM2" && sidebarVisible}
          onClick={handleMenuClick}
          style={currentPLC === "PSM2" ? styles.active : styles.menu_left}
        >
          {" "}
          PSM 2{" "}
        </Menu.Item>
        <Menu.Item
          name="_PSM3"
          active={activeItem === "_PSM3" && sidebarVisible}
          onClick={handleMenuClick}
          style={currentPLC === "PSM3" ? styles.active : styles.menu_left}
        >
          {" "}
          PSM 3{" "}
        </Menu.Item>
        <Menu.Item
          name="_PSM4"
          active={activeItem === "_PSM4" && sidebarVisible}
          onClick={handleMenuClick}
          style={currentPLC === "PSM4" ? styles.active : styles.menu_left}
        >
          {" "}
          PSM 4{" "}
        </Menu.Item>
        <Menu.Item
          name="_PSM5"
          active={activeItem === "_PSM5" && sidebarVisible}
          onClick={handleMenuClick}
          style={currentPLC === "PSM5" ? styles.active : styles.menu_left}
        >
          {" "}
          PSM 5{" "}
        </Menu.Item>

        {/* Request Access Button */}
        {!electronApp && userCopy.hmi_role != "E" && message ? (
          <Menu.Item>
            <Button inverted color="grey" onClick={requestAccess}>
              {/* Prevent UI crash if the socket-driven data is late/missing */}
              {userArr?.[currentPLC]
                ? `Request Access from ${(typeof userArr[currentPLC]?.[1] === "string" ? userArr[currentPLC][1].split(":")[0] : "") || "Admin"}`
                : "Request Access from Admin"}
            </Button>
          </Menu.Item>
        ) : null}

        {/* Urgent Access button (role - a,b,c) */}
        {!electronApp && urgentMsg ? (
          <>
            <Menu.Item>
              <Button inverted color="red" onClick={addUrgentInfo}>
                Urgent Access
              </Button>
            </Menu.Item>
            {urgentModal && <>{urgentAccessModal()}</>}
          </>
        ) : null}

        <Menu.Menu position="right">
          {/* TIMEOUT EXTENDED FEATURE TO TRACK INACTIVITY + DEBUGGING PURPOSE*/}
          {/* <Menu.Item><Icon name={toggleIcon ? 'toggle on' : 'toggle off'} color={toggleIcon ? 'green' : null}/></Menu.Item>
                    {!toggleIcon && !isIdle && <Menu.Item>Inactive: {inactiveSeconds}s</Menu.Item>} */}

          <Menu.Item>
            {" "}
            PPLT ID:{" "}
            {typeof data !== "undefined" && data !== null
              ? data["29144"]
              : ""}{" "}
          </Menu.Item>
          {/* //update 240927, HMI Integrated Version */}
          {/* <Menu.Item> CONFIG: SOFC - {sofcConfig} </Menu.Item> */}
          <Menu.Item> CONFIG: SOFC - S300 </Menu.Item>
          {/* <Menu.Item> CONFIG: {(typeof data !== 'undefined' && data !== null)  ? convertValue(data['9012']) : ''} </Menu.Item> */}
          <Menu.Item>
            {" "}
            {typeof currentPLC !== "undefined" && currentPLC !== null ? (
              currentPLC === "MMON" ? (
                <p>COMMON</p>
              ) : (
                currentPLC
              )
            ) : (
              ""
            )}{" "}
          </Menu.Item>
          {getPPCVersion(currentPLC)}
          {!electronApp ? <User /> : null}
        </Menu.Menu>
      </Menu>
    </div>
  );
};

const styles = {
  header: {
    flexDirection: "row",
    position: "sticky",
    top: "0",
  },
  sticky: {
    position: "sticky",
    top: "0",
    zIndex: "1",
  },
  menu_left: {
    cursor: "pointer",
    width: 100,
    justifyContent: "center",
  },
  active: {
    cursor: "pointer",
    width: 100,
    justifyContent: "center",
    textDecorationLine: "underline",
    fontWeight: "bold",
    fontStyle: "italic",
    color: "skyBlue",
    backgroundColor: "#525252",
  },
  home_button: {
    background: "0 0",
    color: "white",
    border: "none",
    cursor: "pointer",
  },
  alerttext: {
    color: "red",
  },
};

const mapDispatchToProps = (dispatch) => {
  return {
    showSidebar: () => dispatch(showSidebarMenu()),
    setHasHeaderReceived: (hasHeaderReceived) =>
      dispatch(setHasHeaderReceived(hasHeaderReceived)),
    setPPID: (ppid) => dispatch(setPPID(ppid)),
    setHeaderValues: (headerValues) => dispatch(setHeaderValues(headerValues)),
  };
};

const mapStateToProps = (state) => {
  return {
    sidebarVisible: state.nav.sidebarMenuVisible, //redux, sidebarMenuvisible의 상태를 가져옴 (false)
    hasHeaderReceived: state.header.hasHeaderReceived,
    ppid: state.header.ppid,
    headerValues: state.header.headerValues,
    operateVersion: state.header.operateVersion,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderMenu);
